import { render } from "./omnieditor.vue?vue&type=template&id=713681d6"
import script from "./omnieditor.vue?vue&type=script&lang=js"
export * from "./omnieditor.vue?vue&type=script&lang=js"

import "./omnieditor.vue?vue&type=style&index=0&id=713681d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/omnieditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "713681d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('713681d6', __exports__)) {
    api.reload('713681d6', __exports__)
  }
  
  module.hot.accept("./omnieditor.vue?vue&type=template&id=713681d6", () => {
    api.rerender('713681d6', render)
  })

}


export default __exports__